import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

type BadgeVariant = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

const VARIANT_STYLES: Record<BadgeVariant, string> = {
  neutral: 'bg-kw-bg text-kw-shark',
  success: 'bg-kw-emerald-light text-kw-tag-text',
  warning: 'bg-kw-warning-bg text-kw-warning-text',
  danger: 'bg-kw-danger-bg text-kw-danger-text',
  info: 'bg-kw-cerulean-light text-kw-cerulean-dark',
};

export function Badge({ variant = 'neutral', className, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-kw-full px-2 py-0.5 text-[11px] font-medium',
        VARIANT_STYLES[variant],
        className,
      )}
      {...props}
    />
  );
}
